"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.OurStorySupportTitle = exports.OurStorySupportLink = exports.OurStoryStoryLink = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Box)(({
  theme
}) => ({
  margin: theme.spacing(3, 0, 0)
}));
const OurStorySupportLink = exports.OurStorySupportLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'row',
  margin: theme.spacing(3, 0, 0, 0),
  textDecoration: 'none',
  padding: theme.spacing(2, 6),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  height: 50,
  '&:hover, &:focus, &:active': {
    color: theme.palette.text.disabled,
    WebkitTapHighlightColor: 'transparent'
  },
  svg: {
    verticalAlign: 'text-top',
    width: 24,
    height: 24
  }
}));
const OurStorySupportTitle = exports.OurStorySupportTitle = (0, _mui.styled)('span')(({
  theme
}) => ({
  fontSize: '1.7rem',
  fontWeight: theme.typography.fontWeightBold,
  marginLeft: theme.spacing(2),
  textTransform: 'capitalize',
  color: theme.palette.text.secondary
}));
const OurStoryStoryLink = exports.OurStoryStoryLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  display: 'block',
  fontSize: '1.7rem',
  fontWeight: theme.typography.fontWeightBold,
  padding: theme.spacing(2, 6),
  textDecoration: 'none',
  WebkitTapHighlightColor: 'transparent',
  height: 50,
  '&:first-of-type': {
    paddingTop: theme.spacing(2)
  },
  '&:last-of-type': {
    paddingBottom: theme.spacing(2)
  },
  '&:hover, &:focus, &:active': {
    color: theme.palette.text.disabled,
    WebkitTapHighlightColor: 'transparent'
  }
}));